import React from 'react';
import PropTypes from 'prop-types';
import { formatPriceWithCurrency } from '../../tools/format';

/**
 * WssOrderAmountSummary - Displays order total and amount due in WSS payment flow
 */
function WssOrderAmountSummary({
  orderTotalText,
  amountDueText,
  orderTotalFormatted,
  amountDueFormatted,
  currencySymbol,
  currency,
}) {
  return (
    <div className="wss-order-summary">
      <div className="wss-order-summary-wrapper">
        <div className="wss-order-summary-group">
          <div className="wss-order-summary-content">
            <div>
              <span className="h3 order-short-summary__item-title" data-property={orderTotalText?.key}>
                {orderTotalText?.value || 'Order Total:'}
              </span>
              <span className="h3 order-short-summary__item-value">
                {formatPriceWithCurrency(orderTotalFormatted, currencySymbol, currency, true)}
              </span>
            </div>

            <hr className="order-short-summary-hr" />

            <div>
              <span className="h3 order-short-summary__item-title order-short-summary__we-still-need" data-property={amountDueText?.key}>
                {amountDueText?.value || 'We still need:'}
              </span>
              <span className="h3 order-short-summary__item-value order-short-summary__we-still-need">
                {formatPriceWithCurrency(amountDueFormatted, currencySymbol, currency, true)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

WssOrderAmountSummary.propTypes = {
  orderTotalText: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  amountDueText: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  orderTotalFormatted: PropTypes.string,
  amountDueFormatted: PropTypes.string,
  currencySymbol: PropTypes.string,
  currency: PropTypes.string,
};

WssOrderAmountSummary.defaultProps = {
  orderTotalText: null,
  amountDueText: null,
  orderTotalFormatted: '$0.00',
  amountDueFormatted: '$0.00',
  currencySymbol: '$',
  currency: 'USD',
};

export default WssOrderAmountSummary;
